import { Dialog, DialogContent, Box, Typography, Button } from '@mui/material';
import { CheckCircle } from '@mui/icons-material';
import { motion } from 'framer-motion';
import { CardSurface } from '../../ui/CardSurface';
import { ButtonPrimary } from '../../ui/ButtonPrimary';

export function SucessoModal({ open, onClose, mensagem = 'Aferição registrada com sucesso!' }) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: '14px',
        },
      }}
    >
      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.2 }}
      >
        <DialogContent sx={{ p: 0 }}>
          <CardSurface sx={{ p: 4, textAlign: 'center' }}>
            <motion.div
              initial={{ scale: 0 }}
              animate={{ scale: 1 }}
              transition={{ delay: 0.1, type: 'spring', stiffness: 200, damping: 15 }}
            >
              <CheckCircle
                sx={{
                  fontSize: 80,
                  color: 'success.main',
                  mb: 3,
                }}
              />
            </motion.div>

            <Typography
              variant="h5"
              component="h2"
              fontWeight={700}
              gutterBottom
              sx={{ mb: 2 }}
            >
              Sucesso!
            </Typography>

            <Typography
              variant="body1"
              color="text.secondary"
              sx={{ mb: 4, lineHeight: 1.6 }}
            >
              {mensagem}
            </Typography>

            <ButtonPrimary
              onClick={onClose}
              size="large"
              sx={{
                minWidth: 200,
                py: 1.5,
              }}
            >
              OK
            </ButtonPrimary>
          </CardSurface>
        </DialogContent>
      </motion.div>
    </Dialog>
  );
}
